// Simple authentication utilities using session cookies
const TOKEN_KEY = 'auth_token';
const REFRESH_TOKEN_KEY = 'refresh_token';

export const authService = {
  // Store token securely as a session cookie
  setToken: (token: string) => {
    if (typeof document !== 'undefined') {
      const isSecure = window.location.protocol === 'https:';
      const secureFlag = isSecure ? 'Secure' : '';
      document.cookie = `${TOKEN_KEY}=${encodeURIComponent(token)}; path=/; SameSite=Strict; ${secureFlag}`;
    }
  },

  // Get token from the session cookie
  getToken: (): string | null => {
    if (typeof document !== 'undefined') {
      const match = document.cookie.split('; ').find((row) => row.startsWith(`${TOKEN_KEY}=`));
      return match ? decodeURIComponent(match.split('=')[1]) : null;
    }
    return null;
  },

  // Store refresh token securely as a session cookie
  setRefreshToken: (refreshToken: string) => {
    if (typeof document !== 'undefined') {
      const isSecure = window.location.protocol === 'https:';
      const secureFlag = isSecure ? 'Secure' : '';
      document.cookie = `${REFRESH_TOKEN_KEY}=${encodeURIComponent(refreshToken)}; path=/; SameSite=Strict; ${secureFlag}`;
    }
  },

  // Get refresh token from the session cookie
  getRefreshToken: (): string | null => {
    if (typeof document !== 'undefined') {
      const match = document.cookie
        .split('; ')
        .find((row) => row.startsWith(`${REFRESH_TOKEN_KEY}=`));
      return match ? decodeURIComponent(match.split('=')[1]) : null;
    }
    return null;
  },

  // Remove token from the cookie
  removeToken: () => {
    if (typeof document !== 'undefined') {
      document.cookie = `${TOKEN_KEY}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC; SameSite=Strict; Secure`;
    }
  },

  // Remove refresh token from the cookie
  removeRefreshToken: () => {
    if (typeof document !== 'undefined') {
      document.cookie = `${REFRESH_TOKEN_KEY}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC; SameSite=Strict; Secure`;
    }
  },

  // Remove both tokens (for logout)
  clearTokens: () => {
    authService.removeToken();
    authService.removeRefreshToken();
  },

  // Check if user is authenticated
  isAuthenticated: (): boolean => {
    const token = authService.getToken();
    return token !== null && token.length > 0;
  },
};
